import { Component, OnDestroy, OnInit } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import {
  AcceptIdeaCommitteeInput,
  AcceptIdeaGQL,
  AcceptIdeaInput,
  ActionStatusGQL,
  ApprovedIdeaGQL,
  ApproveIdeaExpectationsInput,
  ApproveIdeaInput,
  AwardIdeaGQL,
  Challenge,
  Committee,
  CommitteesGQL,
  CreateIdeaConclusionGQL,
  CreateIdeaConclusionInput,
  DefaultMessage,
  DenyIdeaGQL,
  GetChallengesByLanguageAllGQL,
  GetChallengesByLanguageAllQuery,
  GetIdeaGQL,
  GetIdeaQuery,
  Idea,
  IdeaConclusion,
  RemoveFileGQL,
  ReproveIdeaGQL,
  UpdateIdeaCommitteeGQL,
  ReproveIdeaInput,
  TranslateIdeaChallengeInput,
  TranslateIdeaExpectationInput,
  TranslateIdeaGQL,
  TranslateIdeaInput,
  UpdateIdeaCommitteeInput,
  UpdateIdeaConclusionGQL,
  UpdateIdeaConclusionInput,
  UpdateIdeaImplementationGQL,
  UpdateIdeaImplementationInput,
  User,
  ValidateApproveGQL,
  ValidateApproveQuery,
  UpdateIdeaCodeInput,
  UpdateIdeaCodeGQL,
  UpdateIdeaGQL,
  UpdateIdeaInput,
  SearchUnityInput,
  SearchUnityQuery,
  SearchUnityGQL,
  Unity,
  GetSustainabilitiesGQL,
  IdeaComment,
} from "../../../generated/graphql";
import { QueryRef } from "apollo-angular";
import { UserService } from "../../service/user.service";
import { AnimationOptions } from "ngx-lottie";
import {
  Sustainability,
  SustainabilityService,
} from "src/generated/graphql/sustainability/sustainability.graphql";
import { IRelevantInformation } from "src/app/components/relevant-information/interfaces/relevant-information.interface";
import { UpdateIdeaAuthorGQL } from "src/generated/graphql/idea/author/idea-author.graphql";
import { IdeaAuthorName } from "src/app/components/aprove-idea-authors/types/idea-author-name.type";
import { IIndicator } from "src/app/components/relevant-information/interfaces/indicator.interface";
import { IdeaStoreService } from "src/app/store/idea.store";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { CreateIdeaCommentGQL, CreateIdeaCommentMutationVariables } from "src/generated/graphql/idea/create-comment.graphql";
import { GetAllCommentsByIdGQL } from 'src/generated/graphql/idea/get-all-comments-by-id.graphql';
import { GetIdeaFilesGQL, IdeaFileItem } from 'src/generated/graphql/idea/idea-file/get-idea-files.graphql';
import { environment } from "src/environments/environment";


declare var $: any;

@Component({
  selector: "app-my-list-detail",
  templateUrl: "./my-list-detail.component.html",
  styleUrls: ["./my-list-detail.component.scss"],
})
export class MyListDetailComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  implementationResumeDisabled: boolean = true;
  step = 1;
  user: User = new User();
  paramId = null;
  getIdeaQuery: QueryRef<GetIdeaQuery>;
  searchUnityQuery: QueryRef<SearchUnityQuery>;

  private destroy$ = new Subject<void>();

  validateApproveQuery: QueryRef<ValidateApproveQuery>;
  resultApprove: DefaultMessage = new DefaultMessage();
  idea: Idea;
  authorChangeReason: string;
  committees: Committee[] = [];
  newAuthors: IdeaAuthorName[] = [];
  isModifiedAuthors: boolean = false;
  sustainabilities: Sustainability[] = [];
  acceptIdeaInput: AcceptIdeaInput = new AcceptIdeaInput();
  committeeId: string;
  // modelo do dropdown de busca de comitê (aceite); committeeId continua a fonte da verdade
  committeeSel: { id: string; name: string }[] = [];
  committeeDropSettings: IDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "name",
    itemsShowLimit: 1,
    enableCheckAll: false,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };
  committeeUpdate: string;
  updateIdeaCommitteInput: UpdateIdeaCommitteeInput =
    new UpdateIdeaCommitteeInput();
  updateIdeaCodeInput: UpdateIdeaCodeInput = new UpdateIdeaCodeInput();
  modelTag: string;
  approveIdea: Idea = new Idea();
  ideaConclusion: IdeaConclusion = new IdeaConclusion();
  reproveIdeaInput: ReproveIdeaInput = new ReproveIdeaInput();
  actionStatus: string[] = [];
  unitiesResult: Unity[] = [];
  validateStatus: boolean;
  relevantInformation: IRelevantInformation;

  file: File = null;
  listFiles = [];
  // anexos ativos da ideia (seção "Anexos", fora do card de conclusão)
  ideaFiles: IdeaFileItem[] = [];
  // admin pode adicionar/remover anexos (decidido pela API)
  canManageFiles = false;
  isUpload = false;
  ideaAuthors: IdeaAuthorName[] = [];

  culture: string;

  getChallengeAllQuery: QueryRef<GetChallengesByLanguageAllQuery>;

  challengeResult: Challenge[] = [];

  translateIdeaInputBR: TranslateIdeaInput = new TranslateIdeaInput();
  translateIdeaInputES: TranslateIdeaInput = new TranslateIdeaInput();

  challengeIdBR: string;
  challengeIdES: string;

  financialVoteDescription: string;
  productivityVoteDescription: string;
  sustainabilityVoteDescription: string;

  accessAnimation: AnimationOptions = {
    path: "/assets/lottie/trophy.json",
    renderer: "svg",
    autoplay: true,
    loop: true,
  };

  productivityVote = "";
  sustainabilityVote = "";
  financialVote = "";

  dropSettings: any = {
    singleSelection: false,
    idField: "id",
    textField: "type",
    selectAllText: "Marcar todos",
    unSelectAllText: "Desmarcar todos",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  listStatusItems = [];
  approveIdeaInput: ApproveIdeaInput = new ApproveIdeaInput();
  searchUnityInput: SearchUnityInput = new SearchUnityInput();
  ApproveIdeaExpectationsInput: ApproveIdeaExpectationsInput =
    new ApproveIdeaExpectationsInput();

  modelSonsBR: Idea = new Idea();
  modelSonsES: Idea = new Idea();

  titleES: string = "";
  descriptionES: string = "";
  implementationResumeES: string = "";

  titleBR: string = "";
  descriptionBR: string = "";
  implementationResumeBR: string = "";

  tags: boolean;
  goCommitte: boolean;
  whichCommitee: boolean;
  reproveCommitte: boolean;
  aproveonAnalysis: boolean;
  finalizeAction: boolean;
  finishAwards: boolean;
  editAction: boolean;
  definitionCommitte: boolean;
  concludeIdea: boolean;

  problemAndSolution;
  ideaDescription;
  isIdeaKaizen = false;
  newCode: string;
  indicators: string[];

  productivity: string = "";
  mainAuthorId = "0";
  notTranslatedSustainabilities: IIndicator[] = [];

  IdeaConclusionUpdated: IRelevantInformation = {
    productivityIncrease: 0,
    financialReturn: 0,
    indicators: [
      {
        name: "",
        quantity: 0,
        unity: "",
        pontuation: 0,
      },
    ],
    environmentImpact: 0,
    premiationDate: new Date(),
    totalPontuation: 0,
    financialCriterion: "---",
    sustainabilityCriterion: "---",
    productivityCriterion: "---",
    prize: 0,
    update: false,
  };

  language!: "pt-BR" | "es-ES";
  expandedIndex: number | null = null;

  hasModificationInAuthors: boolean = false;

  currentProblem: string;
  problemSolution: string;

  inputOfCommentIsDisabled: boolean = false;

  comment: string = '';
  minutes: number = 0;
  seconds: number = 5;
  interval: any;
  allComments: IdeaComment[] = []

  isIdeaChallenge: boolean;
  amazonaws = environment.amazonaws;
  
  constructor(
    public router: Router,
    public loading: NgxSpinnerService,
    public route2: ActivatedRoute,
    public userService: UserService,
    private getIdeaGQL: GetIdeaGQL,
    private committeesGQL: CommitteesGQL,
    private validateApproveGQL: ValidateApproveGQL,
    private acceptIdeaGQL: AcceptIdeaGQL,
    private approvedIdeaGQL: ApprovedIdeaGQL,
    private createIdeaConclusionGQL: CreateIdeaConclusionGQL,
    private translateIdeaGQL: TranslateIdeaGQL,
    private getChallengesByLanguageAllGQL: GetChallengesByLanguageAllGQL,
    private awardIdeaGQL: AwardIdeaGQL,
    private updateIdeaImplementationGQL: UpdateIdeaImplementationGQL,
    private updateIdeaConclusionGQL: UpdateIdeaConclusionGQL,
    private reproveIdeaGQL: ReproveIdeaGQL,
    private UpdateIdeaCommitteeGQL: UpdateIdeaCommitteeGQL,
    private UpdateIdeaCodeGQL: UpdateIdeaCodeGQL,
    private denyIdeaGQL: DenyIdeaGQL,
    private actionStatusGQL: ActionStatusGQL,
    private removeFileGQL: RemoveFileGQL,
    private sustainabilityService: SustainabilityService,
    private updateIdeaGQL: UpdateIdeaGQL,
    public translate: TranslateService,
    public searchUnityGQL: SearchUnityGQL,
    private updateIdeaAuthorGQL: UpdateIdeaAuthorGQL,
    private ideaStoreService: IdeaStoreService,
    private createIdeaCommentGQL: CreateIdeaCommentGQL,
    private getIdeaCommentsByIdGQL: GetAllCommentsByIdGQL,
    private getIdeaFilesGQL: GetIdeaFilesGQL,
  ) {
    super(router, loading, translate);
  }

  ngOnInit(): void {
    this.getLanguage();
    Promise.all([this.getCommittees(), this.getUnits()]);
    this.translateCommitteeDropSettings();

    this.userService.user.subscribe({
      next: (data) => {
        this.user = data as User;
        this.userProfile();
      },
      error: (err) => super.onError(err),
    });
    const url = this.route2.snapshot.params as { id: string; code: string };

    this.getIdea(url);
    this.getAllComments(url['id']);
    this.getIdeaFiles(url['id']);

    this.ideaConclusion.productivityVoteDescription = "";
    this.ideaConclusion.sustainabilityVoteDescription = "";
    this.ideaConclusion.financialVoteDescription = "";
  }

  toggleExpand(index: number): void {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

  getLanguage() {
    this.language = localStorage.getItem("culture") as "pt-BR" | "es-ES";
  }

  get activeAuthors() {
    return this.idea?.authors?.filter((author) => !author.remove) || [];
  }

  getIdea(url) {
    this.paramId = url.id;
    this.loading.show();
    this.getIdeaQuery = this.getIdeaGQL.watch({ id: url.id });
    this.getIdeaQuery.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        ({ data }) => {
          this.idea = new Idea();
          this.idea = data.getIdea as Idea;

          this.ideaStoreService.selectedIdea(this.idea);
          localStorage.setItem('committeeId', this.idea.committee?.id)

          this.approveIdea.implementationResume = this.idea?.implementationResume;

          this.productivityVote = this.translateCriterion(
            this.idea.conclusion?.productivityVote,
          );
          this.financialVote = this.translateCriterion(
            this.idea.conclusion?.financialVote,
          );
          this.sustainabilityVote = this.translateCriterion(
            this.idea.conclusion?.sustainabilityVote,
          );

          this.approveIdeaInput.unity = this.idea.unity.id;
          this.approveIdeaInput.committee = this.idea.committee?.id;

          this.notTranslatedSustainabilities = JSON.parse(
            JSON.stringify(this.idea?.sustainabilities),
          );

          if (this.idea.sustainabilities.length) {
            this.idea.sustainabilities.forEach(async (sustainability) => {
              sustainability.name = this.translateIndicator(sustainability.name);
            });
          }

          this.handleIdeaAuthors();

          this.ideaDescription = this.idea.description;
          if (this.idea.code.split("-").includes("K")) {
            this.isIdeaKaizen = true;
            this.problemAndSolution = this.ideaDescription.replace(
              "Possível Solução",
              `\n\nPossível Solução`,
            );
          }

          this.validateStatus = this.handlerStatus();
          this.getEnumType();
          if (data.getIdea.status === "received") {
          }
          if (data.getIdea.status === "analysis") {
            this.committeeUpdate = this.idea.committee.id;
          }

          this.isIdeaChallenge = this.idea.challenge.type === 'personalized' ? true : false;

          this.modelPtEs();
          this.loading.hide();
        },
        (error) => {
          super.onError(error);
          this.router.navigate(["/my-list"]);
        },
      );
  }

  reload() {
    window.location.reload();
  }

  closeModalResume() {
    this.closeModal("ModalResume");
    this.reload();
  }

  showChallengeModal() {
    this.showModal('ModalChallenge');
  }

  handleIdeaAuthors() {
    const firstAuthor: IdeaAuthorName = {
      id: "0",
      name: this.idea.authorName,
      re: this.idea.re,
      email: this.idea.email,
      newName: "",
      newRe: "",
      newEmail: "",
    };

    this.ideaAuthors.push(firstAuthor);
    if (this.idea.authors.length > 0) {
      const authors = this.idea.authors
        .filter(
          (author) =>
            !this.ideaAuthors.some(
              (existingAuthor) => existingAuthor.id === author.id,
            ),
        )
        .map((author) => ({
          id: author.id,
          name: author.name,
          re: author.re,
          email: author.email,
          newName: "",
          newRe: "",
          newEmail: "",
        }));

      this.ideaAuthors = this.ideaAuthors.concat(authors);
    }
  }

  translateCriterion(criterion: string): string {
    switch (criterion) {
      case "parctially attends":
        return this.translate.instant("parctially attends");
      case "not attend":
        return this.translate.instant("not attend");
      case "attend":
        return this.translate.instant("attend");
      case "overcomes":
        return this.translate.instant("overcomes");
      case "above":
        return this.translate.instant("above");
    }
  }

  translateIndicator(indicator: string): string {
    switch (indicator) {
      case "drinking water":
        return this.translate.instant("drinking water");
      case "pw water":
        return this.translate.instant("pw water");
      case "wfi water":
        return this.translate.instant("wfi water");
      case "energy":
        return this.translate.instant("energy");
      case "paper":
        return this.translate.instant("paper");
      case "metal":
        return this.translate.instant("metal");
      case "plastic":
        return this.translate.instant("plastic");
      case "glass":
        return this.translate.instant("glass");
      case "rubber":
        return this.translate.instant("rubber");
      case "danger Residue":
        return this.translate.instant("danger Residue");
      case "glp":
        return this.translate.instant("glp");
      case "gn":
        return this.translate.instant("gn");
      case "diesel":
        return this.translate.instant("diesel");
      case "gas":
        return this.translate.instant("gas");
      case "alcohol":
        return this.translate.instant("alcohol");
      default:
        return indicator;
    }
  }

  changeInput() { }

  modelPtEs() {
    this.modelSonsBR = this.getSon("pt-BR");
    this.modelSonsES = this.getSon("es-ES");

    this.titleBR = this.modelSonsBR.title;
    this.descriptionBR = this.modelSonsBR.description;
    this.implementationResumeBR = this.modelSonsBR.implementationResume;

    this.titleES = this.modelSonsES.title;
    this.descriptionES = this.modelSonsES.description;
    this.implementationResumeES = this.modelSonsES.implementationResume;

    if (this.language === "es-ES") {
      this.modelSonsBR.title = "";
      this.modelSonsBR.description = "";
      this.modelSonsBR.implementationResume = "";
    } else {
      this.modelSonsES.title = "";
      this.modelSonsES.description = "";
      this.modelSonsES.implementationResume = "";
    }
  }

  getSon(language: string) {
    const indexSons = this.idea.sons.findIndex(
      (e) => e.challengeLanguage === language,
    );
    if (indexSons !== -1) {
      return JSON.parse(JSON.stringify(this.idea.sons[indexSons]));
    } else {
      return JSON.parse(JSON.stringify(this.idea));
    }
  }

  ngOnDestroy(): void {
    const elModalCommittee = $("#ModalCommittee");
    const elModalRefusal = $("#ModalRefusal");
    const elModalResume = $("#ModalResume");
    if (elModalCommittee[0]) {
      elModalCommittee.remove();
    }
    if (elModalRefusal[0]) {
      elModalRefusal.remove();
    }
    if (elModalResume[0]) {
      elModalResume.remove();
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  onChangeExpectation(x: any) {
    x.isSelected = !x.isSelected;
  }

  getUnits() {
    this.loading.show();
    this.searchUnityQuery = this.searchUnityGQL.watch({
      input: this.searchUnityInput,
    });
    this.searchUnityQuery.valueChanges.subscribe(({ data }) => {
      this.unitiesResult = data.searchUnity as Unity[];
      this.loading.hide();
    });
  }

  getCommittees() {
    this.committeesGQL.watch({}).valueChanges.subscribe(({ data }) => {
      this.committees = data.committees as Committee[];
    });
  }

  translateCommitteeDropSettings() {
    this.translate
      .stream(["committeeDropdown.search", "committeeDropdown.noResults"])
      .pipe(takeUntil(this.destroy$))
      .subscribe((t) => {
        this.committeeDropSettings = {
          ...this.committeeDropSettings,
          searchPlaceholderText: t["committeeDropdown.search"],
          noFilteredDataAvailablePlaceholderText: t["committeeDropdown.noResults"],
          noDataAvailablePlaceholderText: t["committeeDropdown.noResults"],
        };
      });
  }

  onCommitteeSelect(item: { id: string; name: string }) {
    this.committeeId = item.id;
  }

  onCommitteeDeSelect() {
    this.committeeId = undefined;
    this.committeeSel = [];
  }

  actionRemoveTag(o: any) {
    super.confirmMessage(
      "Atenção",
      "Deseja realmente deletar essa tag?",
      () => {
        this.acceptIdeaInput.tags = this.acceptIdeaInput.tags.filter(
          (item) => item !== o,
        );
      },
    );
  }

  createTag(s: any) {
    if (
      this.isNullOrUndefined(this.modelTag) ||
      this.isNullOrUndefined(this.modelTag.trim())
    ) {
      return;
    }
    this.acceptIdeaInput.tags = !this.isNullOrUndefined(
      this.acceptIdeaInput.tags,
    )
      ? this.acceptIdeaInput.tags
      : [];
    if (this.acceptIdeaInput.tags.some((x) => x === s)) {
      this.showMessage("Atenção", `Já existe uma tag cadastrada.`);
      return;
    }
    this.acceptIdeaInput.tags = !this.isNullOrUndefined(
      this.acceptIdeaInput.tags,
    )
      ? Object.assign([], this.acceptIdeaInput.tags)
      : [];
    this.acceptIdeaInput.tags.push(s);
    this.modelTag = null;
  }

  onAcceptIdea() {
    const arrValidateFields = [
      { value: this.acceptIdeaInput.tags, text: "Tags<br>" },
      { value: this.committeeId, text: "Comitê<br>" },
    ];
    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return;
    }
    const acceptIdeaCommitteeInput: AcceptIdeaCommitteeInput = {
      id: this.committeeId,
    };
    this.acceptIdeaInput.id = this.paramId;
    this.acceptIdeaInput.committee = acceptIdeaCommitteeInput;
    this.loading.show();
    this.acceptIdeaGQL.mutate({ input: this.acceptIdeaInput }).subscribe(
      ({ data }) => {
        this.getIdeaQuery.refetch({ id: data.acceptIdea.id });
        this.loading.hide();
        this.showMessage(
          "Sucesso!",
          `Ideia enviada para o comitê com sucesso!`,
          "success",
        );

        setTimeout(() => {
          this.reload();
        }, 1000);
      },
      (err) => super.onError(err),
    );
  }

  getActionByType(type: string) {
    return this.idea.action.filter((e) => e.status === type);
  }

  onAnalysis(id) {
    this.validateApproveGQL.watch({ id }).valueChanges.subscribe(({ data }) => {
      this.resultApprove = data.validateApproveIdea as DefaultMessage;
      if (this.resultApprove.status === 200) {
        this.closeModal("ModalChallenge");
        this.showModal("ModalResume");

        this.approveIdea.title = this.idea.title;
        this.approveIdea.implementationResume = undefined;
        this.approveIdea.premiationDate = this.idea.premiationDate;

        this.setDate("picker-premiationDate", (start, end, label) => {
          this.approveIdea.premiationDate = end.utcOffset(0, true).format();
        });
      } else {
        return;
      }
    });
  }

  onApproved() {
    this.ideaConclusion.financialVoteDescription = this.idea?.expectations.find(
      (s) => s.expectation == "finance-admin",
    )?.expectationDescription;
    this.ideaConclusion.productivityVoteDescription =
      this.idea?.expectations.find(
        (s) => s.expectation == "productive-admin",
      )?.expectationDescription;
    this.ideaConclusion.sustainabilityVoteDescription =
      this.idea?.expectations.find(
        (s) => s.expectation == "sustainability-admin",
      )?.expectationDescription;
    this.showModal("ModalCommittee");
  }

  onAward() {
    super.confirmMessage("Atenção", "Deseja finalizar a ideia ?", () => {
      this.loading.show();
      this.awardIdeaGQL.mutate({ input: this.paramId }).subscribe(
        ({ data }) => {
          this.getIdeaQuery.refetch({ id: data.awardIdea.id });
          this.loading.hide();
          this.showMessage(
            "Sucesso!",
            `Premiação Concluida com sucesso!`,
            "success",
          );
          const step = this.language === "pt-BR" ? 1 : 2;

          this.showModalTranslateESPT(step);
        },
        (err) => {
          this.loading.hide();
          super.onError(err);
        },
      );
    });
  }

  clickStep(s: number) {
    this.step = s;
    this.getChanlenge();
  }

  showModalTranslateESPT(x: number) {
    this.step = x;
    this.openModalTranslateESPT();

    this.getChanlenge();
  }

  openModalTranslateESPT() {
    this.modelSonsBR = this.getSon("pt-BR");
    this.modelSonsES = this.getSon("es-ES");

    this.showModal("modalTranslateESPT");
  }

  closeModalTranslateESPT() {
    this.closeModal("modalTranslateESPT");
  }

  getChanlenge() {
    if (this.step === 1) {
      this.culture = "pt-BR";
    } else {
      this.culture = "es-ES";
    }
    this.getChallengeAllQuery = this.getChallengesByLanguageAllGQL.watch({
      input: this.culture,
    });
    this.getChallengeAllQuery.valueChanges.subscribe(({ data }) => {
      this.challengeResult = data.getChallengesByLanguageAll as Challenge[];
    });
  }

  ideaTranslate() {
    const arrValidateFields = [
      { value: this.modelSonsBR.title, text: "Título Português<br>" },
      { value: this.modelSonsBR.description, text: "Descrição Português<br>" },
      {
        value: this.modelSonsBR.implementationResume,
        text: "Resumo da implantação e ganhos Português<br>",
      },

      { value: this.modelSonsES.title, text: "Título Espanhol<br>" },
      { value: this.modelSonsES.description, text: "Descrição Espanhol<br>" },
      {
        value: this.modelSonsES.implementationResume,
        text: "Resumo da implantação e ganhos Espanhol<br>",
      },
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return;
    }
    let translateIdeaExpectationInputBR: TranslateIdeaExpectationInput[] = [];
    this.modelSonsBR.expectations.forEach((e) => {
      translateIdeaExpectationInputBR.push({
        id: e.id,
        expectationDescription: e.expectationDescription,
        expectation: e.expectation,
      });
    });
    const translateIdeaChallengeInputBR: TranslateIdeaChallengeInput = {
      id: this.idea?.challenge?.id,
    };
    this.translateIdeaInputBR = {
      challengeLanguage: "pt-BR",
      challengeId: translateIdeaChallengeInputBR,
      analysisDescription: this.modelSonsBR.analysisDescription,
      description: this.modelSonsBR.description,
      expectation: translateIdeaExpectationInputBR,
      motive: this.modelSonsBR.motive,
      productiveDescription: this.modelSonsBR.productiveDescription,
      title: this.modelSonsBR.title,
      implementationResume: this.modelSonsBR.implementationResume,
      id: this.idea.id,
    };

    let translateIdeaExpectationInputES: TranslateIdeaExpectationInput[] = [];
    this.modelSonsES.expectations.forEach((e) => {
      translateIdeaExpectationInputES.push({
        id: e.id,
        expectationDescription: e.expectationDescription,
        expectation: e.expectation,
      });
    });

    const translateIdeaChallengeInputES: TranslateIdeaChallengeInput = {
      id: this.idea?.challenge?.id,
    };
    this.translateIdeaInputES = {
      challengeLanguage: "es-ES",
      challengeId: translateIdeaChallengeInputES,
      analysisDescription: this.modelSonsES.analysisDescription,
      description: this.modelSonsES.description,
      expectation: translateIdeaExpectationInputES,
      motive: this.modelSonsES.motive,
      productiveDescription: this.modelSonsES.productiveDescription,
      title: this.modelSonsES.title,
      implementationResume: this.modelSonsES.implementationResume,
      id: this.idea.id,
    };

    this.loading.show();
    this.translateIdeaGQL
      .mutate({ input: [this.translateIdeaInputBR, this.translateIdeaInputES] })
      .subscribe(
        ({ data }) => {
          this.getIdeaQuery.refetch({ id: this.paramId }).then();
          this.closeModal("modalTranslateESPT");
          this.showMessage(
            "Sucesso",
            `Idea atualizada com sucesso!`,
            "success",
          );
          this.loading.hide();
        },
        (err) => super.onError(err),
      );
  }

  validateFieldsOfIdeaImplementation(): boolean {
    const arrValidateFields = [
      { value: this.approveIdea?.implementationResume, text: "Descrição<br>" },
      {
        value: this.approveIdea?.premiationDate,
        text: "Data da premiação<br>",
      },
    ];

    if (this.isModifiedAuthors) {
      arrValidateFields.push({
        value: this.authorChangeReason,
        text: "Justificativa pela troca do autor<br>",
      });
    }

    const stringError = this.validateField(arrValidateFields);

    if (!this.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return false;
    }

    return true;
  }

  validateFieldsOfIdeaConclusion(): boolean {
    const regex = /^-+$/i; // match "---"

    const voteFields = [
      {
        key: "financialVote",
        descriptionKey: "financialVoteDescription",
        text: "Justificativa - Financeiro<br>",
      },
      {
        key: "sustainabilityVote",
        descriptionKey: "sustainabilityVoteDescription",
        text: "Justificativa - Sustentabilidade<br>",
      },
      {
        key: "productivityVote",
        descriptionKey: "productivityVoteDescription",
        text: "Justificativa - Produtividade<br>",
      },
    ];

    const arrValidateFields = [
      {
        value: this.ideaConclusion.productivityVote.replace(regex, ""),
        text: "Votação produtividade<br>",
      },
      {
        value: this.ideaConclusion.sustainabilityVote.replace(regex, ""),
        text: "Votação sustentabilidade<br>",
      },
      {
        value: this.ideaConclusion.financialVote.replace(regex, ""),
        text: "Votação retorno financeiro<br>",
      },
      { value: this.ideaConclusion.prize, text: "Valor do prêmio<br>" },
      { value: this.ideaConclusion.points, text: "Valor da pontuação<br>" },
    ];

    voteFields.forEach(({ key, descriptionKey, text }) => {
      if (this.ideaConclusion[key] !== "not attend") {
        arrValidateFields.push({
          value: this.ideaConclusion[descriptionKey]?.trim(),
          text,
        });
      }

      if (this.ideaConclusion[key] === "not attend") {
        this.ideaConclusion[descriptionKey] = this.ideaConclusion[
          descriptionKey
        ]?.trim()
          ? this.ideaConclusion[descriptionKey]?.trim()
          : null;
      }
    });

    const stringError = this.validateField(arrValidateFields);

    if (!this.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return false;
    }

    return true;
  }

  valideFieldsOfUpdateAuthors(): boolean {
    const arrValidateFields = [];

    const hasNewAuthor = this.newAuthors.some((author) => {
      return author.newName || author.newRe || author.newEmail;
    });

    if (hasNewAuthor) {
    }

    const stringError = this.validateField(arrValidateFields);

    if (!this.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return false;
    }
  }

  setIdeaExpectations(addSuffix: boolean = true) {
    let approveIdeaExpectationsInput: ApproveIdeaExpectationsInput[] = [];
    this.idea.expectations.forEach((e) => {
      approveIdeaExpectationsInput.push({
        expectation: addSuffix ? `${e.expectation}-admin` : e.expectation,
        expectationDescription: e.expectationDescription,
      });
    });
    return approveIdeaExpectationsInput;
  }

  setIdeaImplementationInput(): ApproveIdeaInput {
    const mainAuthor = this.getMainAuthorUpdated();
    const approveIdeaExpectationsInput = this.setIdeaExpectations();

    return {
      id: this.paramId,
      implementationResume: this.approveIdea.implementationResume,

      analysisFinacialreturn: this.relevantInformation.financialReturn || 0,
      productivityValueHH: this.relevantInformation.productivityIncrease || 0,
      sustentabilityPoint: this.relevantInformation.environmentImpact || 0,

      analysisMachineValue: this.approveIdea.analysisMachineValue,
      analysisManValue: this.approveIdea.analysisManValue,
      analysisSustainability: this.approveIdea.analysisSustainability,

      premiationDate: this.relevantInformation.premiationDate,
      sustainability: this.approveIdeaInput.sustainability,
      expectations: approveIdeaExpectationsInput,
      status: "approved_award",
      authorName: mainAuthor?.name,
      re: mainAuthor?.re,
      email: mainAuthor?.email,
    };
  }

  setUpdateIdeaImplementaionInput(): UpdateIdeaImplementationInput {
    const mainAuthor = this.getMainAuthorUpdated();
    const approveIdeaExpectationsInput = this.setIdeaExpectations(false);

    return {
      id: this.paramId,
      implementationResume: this.approveIdea.implementationResume,

      productivityValueHH: this.relevantInformation.productivityIncrease,
      analysisFinacialreturn: this.relevantInformation.financialReturn,
      sustentabilityPoint: this.relevantInformation.environmentImpact,

      analysisMachineValue: this.approveIdea.analysisMachineValue,
      analysisManValue: this.approveIdea.analysisManValue,
      analysisSustainability: this.approveIdea.analysisSustainability,
      premiationDate: this.relevantInformation?.premiationDate,
      sustainability: this.approveIdeaInput.sustainability,
      expectations: approveIdeaExpectationsInput,
      authorName: mainAuthor.name,
      re: mainAuthor.re,
      email: mainAuthor.email,
    };
  }

  setIdeaConclusionInput(): CreateIdeaConclusionInput {
    return {
      productivityVote: this.ideaConclusion.productivityVote,
      sustainabilityVote: this.ideaConclusion.sustainabilityVote,
      financialVote: this.ideaConclusion.financialVote,

      financialVoteDescription: this.ideaConclusion.financialVoteDescription,
      productivityVoteDescription:
        this.ideaConclusion.productivityVoteDescription,
      sustainabilityVoteDescription:
        this.ideaConclusion.sustainabilityVoteDescription,

      prize: this.ideaConclusion.prize,
      points: this.ideaConclusion.points,

      idea: { id: this.paramId },
    };
  }

  setUpdateIdeaConclusionInput(): UpdateIdeaConclusionInput {
    return {
      id: this.ideaConclusion.id,
      productivityVote: this.ideaConclusion.productivityVote,
      productivityVoteDescription:
        this.ideaConclusion.productivityVoteDescription,

      sustainabilityVote: this.ideaConclusion.sustainabilityVote,
      sustainabilityVoteDescription:
        this.ideaConclusion.sustainabilityVoteDescription,

      financialVote: this.ideaConclusion.financialVote,
      financialVoteDescription: this.ideaConclusion.financialVoteDescription,

      prize: this.ideaConclusion.prize,
      points: this.ideaConclusion.points,

      idea: { id: this.paramId },
    };
  }

  setPremiationDateAndIdeaSustainability() {
    this.approveIdea.premiationDate = this.relevantInformation?.premiationDate;
    this.approveIdeaInput.sustainability = [];
    this.listStatusItems.forEach((e) => {
      this.approveIdeaInput.sustainability.push({ id: e.id });
    });
  }

  async onImplementation() {
    if (this.hasModificationInAuthors) {
      this.showMessage("Atenção", "Salve os autores antes de continuar");
      return;
    }

    this.setPremiationDateAndIdeaSustainability();

    const isValidFieldsOfImplementation =
      this.validateFieldsOfIdeaImplementation();
    const isValidFieldsOfConclusion = this.validateFieldsOfIdeaConclusion();

    if (!isValidFieldsOfImplementation || !isValidFieldsOfConclusion) {
      return;
    }

    this.loading.show();
    if (this.isNullOrUndefined(this.idea.implementationResume)) {
      this.createImplementation();
    } else {
      this.updateImplementation();
    }
  }

  createImplementation() {
    const input = this.setIdeaImplementationInput();

    this.approvedIdeaGQL.mutate({ input }).subscribe(
      () => {
        this.onIdeaConclusion();
        this.closeModal("ModalResume");
        this.showMessage("Sucesso!", `Ideia aprovada com sucesso!`, "success");
      },
      (err) => {
        this.loading.hide();
        super.onError(err);
      },
    );
  }

  updateImplementation() {
    const input = this.setUpdateIdeaImplementaionInput();

    this.updateIdeaImplementationGQL.mutate({ input }).subscribe(
      () => {
        this.onIdeaConclusion();
        this.closeModal("ModalResume");
        this.showMessage(
          "Sucesso!",
          `Implantação da ideia alterado com sucesso!`,
          "success",
        );
      },
      (err) => {
        this.loading.hide();
        this.onError(err);
      },
    );
  }

  updateIdeaStatus(status: string): void {
    const data = {
      id: this.idea?.id,
      status,
    }

    this.updateIdeaGQL.mutate({ input: data }).subscribe({
      next: () => {
        this.showMessage('Sucesso', 'Ideia Desafio finalizada com sucesso!', 'success')

        setTimeout(() => {
          this.reload()
        }, 1000)
      },
      error: (error) => {
        this.onError(error)
      }
    })
  }

  onIdeaConclusion() {
    if (this.isNullOrUndefined(this.ideaConclusion.id)) {
      this.CreateIdeaConclusion();
    } else {
      this.UpdateIdeaConclusion();
    }
  }

  CreateIdeaConclusion() {
    const input = this.setIdeaConclusionInput();

    this.createIdeaConclusionGQL.mutate({ input }).subscribe(
      () => {
        this.onCreateOrUpdateSustainability();
      },
      (err) => {
        this.loading.hide();
        this.onError(err);
      },
    );
  }

  UpdateIdeaConclusion() {
    const input = this.setUpdateIdeaConclusionInput();

    this.updateIdeaConclusionGQL.mutate({ input }).subscribe(
      () => {
        this.onCreateOrUpdateSustainability();
        this.closeModal("ModalCommittee");
      },
      (err) => {
        this.loading.hide();
        super.onError(err);
      },
    );
  }

  onEditIdeaConclusion() {
    this.approveIdea = new Idea();
    this.approveIdea = this.idea;
    this.ideaConclusion = this.idea?.conclusion;

    this.productivityVote = this.translateCriterion(
      this.idea?.conclusion?.productivityVote,
    );
    this.financialVote = this.translateCriterion(
      this.idea?.conclusion?.financialVote,
    );
    this.sustainabilityVote = this.translateCriterion(
      this.idea?.conclusion?.sustainabilityVote,
    );

    const data = {
      id: this.idea?.conclusion?.id,
      indicators: this.notTranslatedSustainabilities,
      productivityIncrease: this.idea?.productivityValueHH,
      financialReturn: this.idea?.analysisFinacialreturn,
      environmentImpact: this.idea?.sustentabilityPoint,
      productivityCriterion: this.productivityVote,
      financialCriterion: this.financialVote,
      sustainabilityCriterion: this.sustainabilityVote,
      premiationDate: this.idea?.premiationDate as Date,
      prize: this.idea?.conclusion?.prize,
      totalPontuation: this.idea?.conclusion?.points,
      update: true,
    };

    console.log("my list");
    console.log(data);

    this.IdeaConclusionUpdated = data;

    this.showModal("ModalResume");
  }

  async onCreateOrUpdateSustainability() {
    for (const indicator of this.relevantInformation.indicators) {
      const input = {
        id: indicator.id,
        name: indicator?.name,
        quantity: indicator?.quantity,
        unity: indicator?.unity,
        ideaId: this.idea?.id,
        pontuation: indicator?.pontuation,
      };

      try {
        if (!indicator.id) {
          const { id, ...createInput } = input;
          await this.sustainabilityService.createSustainability(createInput);
        } else {
          const { ideaId, ...updateInput } = input;
          await this.sustainabilityService.updateSustainability(updateInput);
        }
      } catch {
        this.loading.hide();
        console.error("Error to process sustainability");
      }

      this.loading.hide();

      setTimeout(() => {
        this.reload();
      }, 1000);
    }

    if (!this.relevantInformation.indicators.length) {
      setTimeout(() => {
        this.reload();
      }, 1000);
      this.loading.hide();
    }
  }

  onEditDefinition() {
    this.idea.conclusion = Object.assign({}, this.idea.conclusion);
    this.ideaConclusion = this.idea.conclusion;
    if (!this.isNullOrUndefined(this.idea.conclusion, true)) {
      this.productivityVote = this.idea.conclusion.productivityVote;
      this.sustainabilityVote = this.idea.conclusion.sustainabilityVote;
      this.financialVote = this.idea.conclusion.financialVote;
      this.financialVoteDescription =
        this.idea.conclusion.financialVoteDescription;
      this.sustainabilityVoteDescription =
        this.idea.conclusion.sustainabilityVoteDescription;
      this.productivityVoteDescription =
        this.idea.conclusion.productivityVoteDescription;
    }
    this.showModal("ModalCommittee");
  }

  changeDenialStatus() {
    const idDenialStatus = this.paramId;
    this.denyIdeaGQL.mutate({ id: idDenialStatus }).subscribe(
      ({ data }) => {
        this.closeModal("ModalDenial");
        this.getIdeaQuery.refetch({ id: this.paramId });
        this.loading.hide();
        this.showMessage(
          "Sucesso!",
          `Sua Ideia mudou para reprovada com sucesso!`,
          "success",
        );
      },
      (err) => super.onError(err),
    );
  }

  onReprove() {
    if (this.idea.status === "analysis") {
      this.showModal("ModalRefusal");
    } else {
      this.reproveIdeaInput = new ReproveIdeaInput();
      this.showModal("ModalRefusal");
    }
  }

  // UPLOAD FILE MODAL
  handlerUpload(event) {
    const files = event.target.files;
    if (files.length > 0) {
      if (files[0].size > 60000000) {
        super.showMessage(
          this.translate.instant("baseComponent.warningAttention"),
          this.translate.instant("baseComponent.warningMsgUploadFileMaxSize"),
          "info",
        );
        return;
      }
    }
    const reader = new FileReader();
    reader.onload = (file) => {
      this.listFiles.push({ file: files[0], path: file.target.result });
    };
    reader.readAsDataURL(event.target.files[0]);
    this.file = null;
    this.isUpload = false;
  }

  actionUploadFile(id: string, navigator = true) {
    if (this.listFiles.length === 0) {
      this.getIdeaQuery.refetch({ id: this.paramId });
      this.loading.hide();
    }
    this.listFiles.forEach((x, index) => {
      this.userService.upload(x.file, id, "idea").subscribe({
        next: (data) => {
          if (this.listFiles.length === index + 1) {
            this.isUpload = true;
            this.loading.hide();
            this.getIdeaQuery.refetch({ id: this.paramId });
            this.listFiles = [];
            if (navigator) {
              this.router.navigate(["/my-list"]);
            }
          }
        },
        error: (err) => super.onError(err),
      });
    });
  }

  handlerStatus() {
    switch (this.idea.status) {
      case "awarded":
        return false;
      default:
        return true;
    }
  }

  getEnumType() {
    this.actionStatusGQL.watch().valueChanges.subscribe(
      ({ data }) => {
        this.actionStatus = data.actionStatus as string[];
      },
      (error) => this.onError(error),
    );
  }

  onRemoveFileList(i: number) {
    super.confirmMessage(
      "Atenção",
      "Deseja realmente deletar esse arquivo?",
      () => {
        this.listFiles.splice(i, 1);
      },
    );
  }

  onRemoveFile(id: string, i: number) {
    super.confirmMessage(
      "Atenção",
      "Deseja realmente deletar esse arquivo?",
      () => {
        this.removeFileGQL.mutate({ id }).subscribe(
          ({ data }) => {
            this.approveIdea.ideafiles.splice(i, 1);
            this.showMessage(
              "Sucesso!",
              "Arquivo deletado com sucesso!",
              "success",
            );
          },
          (error) => super.onError(error),
        );
      },
    );
  }

  handlerSustainability(sustainabilities: Array<Sustainability>) {
    const response = [];

    if (sustainabilities) {
      for (let sustainability of sustainabilities) {
        const translation = this.getTranslate(sustainability.id);
        response.push(translation);
      }
      return response.join("|");
    }
  }

  userProfile() {
    switch (this.user.role) {
      case "admin":
        this.tags = true;
        this.whichCommitee = true;
        this.reproveCommitte = true;
        this.goCommitte = true;
        this.finalizeAction = true;
        this.aproveonAnalysis = true;
        this.finishAwards = true;
        this.editAction = true;
        this.definitionCommitte = true;
        this.concludeIdea = true;
        break;
      case "user":
        this.tags = true;
        this.whichCommitee = true;
        this.reproveCommitte = true;
        this.goCommitte = true;
        this.finalizeAction = true;
        this.aproveonAnalysis = true;
        this.finishAwards = true;
        this.editAction = true;
        this.definitionCommitte = true;
        this.concludeIdea = true;
        break;
      case "corporate-manager":
        this.tags = true;
        this.whichCommitee = true;
        this.reproveCommitte = true;
        this.goCommitte = true;
        this.finalizeAction = true;
        this.aproveonAnalysis = true;
        this.finishAwards = true;
        this.editAction = true;
        this.definitionCommitte = true;
        this.concludeIdea = true;
        break;
      case "local-manager":
        this.tags = true;
        this.whichCommitee = true;
        this.reproveCommitte = true;
        this.goCommitte = true;
        this.finalizeAction = true;
        this.aproveonAnalysis = true;
        this.finishAwards = true;
        this.editAction = true;
        this.definitionCommitte = true;
        this.concludeIdea = true;
        break;
      case "committee-member":
        this.tags = false;
        this.whichCommitee = true;
        this.reproveCommitte = true;
        this.goCommitte = true;
        this.finalizeAction = false;
        this.aproveonAnalysis = false;
        this.finishAwards = false;
        this.editAction = false;
        this.definitionCommitte = false;
        this.concludeIdea = true;
        break;
    }
  }

  reproveIdea() {
    const arrValidateFields = [
      { value: this.reproveIdeaInput.motive, text: "Descreva aqui<br>" },
    ];
    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return;
    }

    this.reproveIdeaInput.userId = this.user.id;
    this.reproveIdeaInput.id = this.paramId;

    this.reproveIdeaGQL.mutate({ input: this.reproveIdeaInput }).subscribe(
      () => {
        this.closeModal("ModalRefusal");
        this.getIdeaQuery.refetch({ id: this.paramId });
        this.loading.hide();
        this.showMessage("Sucesso!", `Ideia reprovada com sucesso!`, "success");
        setTimeout(() => {
          this.reload()
        }, 1000)
      },
      (err) => {
        super.onError(err)
        this.loading.hide();
      },
    );
  }

  updateCommittee() {
    this.updateIdeaCommitteInput = {
      id: this.idea.id,
      committe: { id: this.committeeUpdate },
    };
    this.UpdateIdeaCommitteeGQL.mutate({
      input: this.updateIdeaCommitteInput,
    }).subscribe(
      async () => {
        location.reload();
      },
      (err) => super.onError(err),
    );
  }

  updateCode() {
    this.updateIdeaCodeInput = { id: this.idea.id, code: this.newCode };
    this.UpdateIdeaCodeGQL.mutate({
      input: this.updateIdeaCodeInput,
    }).subscribe(
      async () => {
        this.showMessage("Sucesso!", `Código alterado com sucesso!`, "success");
        location.reload();
      },
      (err) => super.onError(err),
    );
  }

  onRelevantInformationChange(relevantInformation: IRelevantInformation) {
    this.relevantInformation = relevantInformation;

    this.ideaConclusion.financialVote = relevantInformation.financialCriterion;
    this.ideaConclusion.sustainabilityVote =
      relevantInformation.sustainabilityCriterion;
    this.ideaConclusion.productivityVote =
      relevantInformation.productivityCriterion;
    this.ideaConclusion.points = relevantInformation.totalPontuation;
    this.ideaConclusion.prize = relevantInformation.prize;
  }

  onNewAuthorsChange({
    authors,
    isModifiedAuthors,
  }: {
    authors: [];
    isModifiedAuthors: boolean;
  }) {
    this.newAuthors = authors;
    this.isModifiedAuthors = isModifiedAuthors;
  }

  onAuthorChangeReason(value: string) {
    this.authorChangeReason = value;
  }

  onCommitteeChange() {
    this.updateIdeaCommitteInput = {
      id: this.idea.id,
      committe: { id: this.approveIdeaInput.committee },
    };
    this.UpdateIdeaCommitteeGQL.mutate({
      input: this.updateIdeaCommitteInput,
    }).subscribe({
      next: () => { },
      error: (error) => {
        super.onError(error);
      },
    });
  }

  onUpdateIdea(data) {
    const updateIdeaInput: UpdateIdeaInput = {
      id: this.idea.id,
      status: this.idea.status,
      ...data,
    };

    this.updateIdeaGQL.mutate({ input: updateIdeaInput }).subscribe({
      next: () => { },
      error: (error) => {
        super.onError(error);
      },
    });
  }

  getMainAuthorUpdated() {
    const mainAuthorUpdated = this.newAuthors?.find(
      (item) => item.id === this.mainAuthorId,
    );
    return {
      name:
        mainAuthorUpdated?.newName ||
        mainAuthorUpdated?.name ||
        this.idea.authorName,
      re: mainAuthorUpdated?.newRe || mainAuthorUpdated?.re || this.idea.re,
      email:
        mainAuthorUpdated?.newEmail ||
        mainAuthorUpdated?.email ||
        this.idea.email,
    };
  }

  async onUpdateIdeaAuthors(): Promise<void> {
    if (!this.newAuthors) return;

    const updatePromises = this.newAuthors.map((item) => {
      if (item.id !== this.mainAuthorId) {
        const input = {
          id: item.id,
          name: item.newName ? item.newName : item.name,
          re: item.newRe ? item.newRe : item.re,
          email: item.newEmail ? item.newEmail : item.email,
          ideaId: this.idea.id,
        };

        return new Promise<void>((resolve, reject) => {
          this.updateIdeaAuthorGQL.mutate({ input }).subscribe({
            next: () => resolve(),
            error: (err) => reject(err),
          });
        });
      }
      return Promise.resolve();
    });

    await Promise.all(updatePromises);
  }

  getInforsOfFormAuthors(hasModificationInForm: boolean) {
    this.hasModificationInAuthors = hasModificationInForm;
  }


  startTimer() {
    this.inputOfCommentIsDisabled = true;
    this.interval = setInterval(() => {
      if (this.seconds > 0) {
        this.seconds--;
      } else if (this.minutes > 0 && this.seconds === 0) {
        this.minutes--;
        this.seconds = 59;
      } else {
        clearInterval(this.interval);

        this.minutes = 0;
        this.seconds = 5;
        this.inputOfCommentIsDisabled = false;
      }
    }, 1000);
  }

  formatTime(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  onComment(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      const commentIsValid = this.validadeComment()

      if (commentIsValid) {
        this.allComments.unshift({
          id: Date.now().toString(),
          name: this.user.name,
          message: this.comment,
          createdAt: new Date(),
          status: 'PENDING',
          deletedAt: null
        })

        this.createIdeaComment()
        this.startTimer()
        this.comment = ''
      }
    }
  }

  validadeComment(): boolean {
    const arrValidateFields = [
      { value: this.comment, text: 'Comentário<br>' },
    ];

    const stringError = this.validateField(arrValidateFields);

    if (!this.isNullOrUndefined(stringError)) {
      this.showMessage(this.translate.instant('baseComponent.warningAttention'), `${this.translate.instant('baseComponent.warningCorrectFields')} <br> ${stringError}`);
      return false;
    }

    return true;
  }

  createIdeaComment() {
    const data: CreateIdeaCommentMutationVariables = {
      id: this.idea?.id,
      data: {
        name: this.user?.name,
        message: this.comment,
      }
    }

    this.createIdeaCommentGQL.mutate(data).subscribe({
      next: () => {
        this.showMessage('Sucesso', 'Comentário adicionado com sucesso', 'success')
      },
      error: () => {
        this.showMessage('Atnção', 'Erro ao tentar adicionar comentário', 'error')
      },
    })
  }

  getIdeaFiles(id: string) {
    this.getIdeaFilesGQL
      .fetch({ id }, { fetchPolicy: "network-only" })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ({ data }) => {
          this.ideaFiles = data?.getIdea?.ideafiles || [];
          this.canManageFiles = !!data?.getIdea?.canManageFiles;
        },
        error: () => {},
      });
  }

  getAllComments(id: string) {
    this.getIdeaCommentsByIdGQL.watch({ id }).valueChanges.subscribe({
      next: (response) => {
        this.allComments = response.data.getAllIdeaCommentById;
      },
      error: () => { },
    })
  }

}
